/**
 * The weekly pipeline series, with its own state.
 *
 * ⚠️ A THIRD ENDPOINT WITH A THIRD FAILURE MODE, alongside the tracking read and the candidate
 * funnel, and that is the point of giving it its own hook: Tracking's delivery figures come from
 * the Hiring Database, the funnel and this come from the warehouse through two different queries,
 * and no one of them going down may blank the others. The Trends tile shows a dash and its section
 * says so; everything else on the tab is untouched.
 */
import { useEffect, useState } from 'react';
import { fetchPipelineTrends } from '../../../services/openPositionsApi';
import type { PipelineTrends } from '../../../types/pipelineTrends';

export function usePipelineTrends() {
  const [data, setData] = useState<PipelineTrends | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchPipelineTrends()
      .then((d) => {
        if (cancelled) return;
        setData(d);
        setError(null);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        setError(e instanceof Error ? e.message : String(e));
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, error, loading };
}
